// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero-search-wrapper[data-v-502cdaec]{background-color:#fff;max-width:912px}.hero-search[data-v-502cdaec]{height:64px;box-shadow:0px 4px 48px rgba(1,3,20,.16)}@media(max-width: 767.98px){.hero-search[data-v-502cdaec]{height:48px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
